import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import TabSelector from '../components/tab-selector'
import TabSelector2 from '../components/tab-selector-2'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Cipta Srigati Lestari</title>
        <meta
          name="description"
          content="Kartu pintar, Smartcard, Smart Card Solution, Personalized Card "
        />
        <meta property="og:title" content="Cipta Srigati Lestari" />
        <meta
          property="og:description"
          content="Kartu pintar, Smartcard, Smart Card Solution, Personalized Card "
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Cipta Srigati Lestari" />
        <meta
          name="twitter:description"
          content="Kartu pintar, Smartcard, Smart Card Solution, Personalized Card "
        />
        <link
          rel="canonical"
          href="https://glittering-artistic-eagle-6fustt.teleporthq.site/"
        />
        <meta
          property="og:url"
          content="https://glittering-artistic-eagle-6fustt.teleporthq.site/"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Organization","name":"Cipta Srigati Lestari","url":"https://glittering-artistic-eagle-6fustt.teleporthq.site"}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"WebSite","name":"Cipta Srigati Lestari","url":"https://glittering-artistic-eagle-6fustt.teleporthq.site","description":"Kartu pintar, Smartcard, Smart Card Solution, Personalized Card "}',
          }}
        />
      </Helmet>
      <header className="home-container2">
        <header
          data-thq="thq-navbar"
          className="home-thq-navbar-interactive-elm"
        >
          <img
            loading="eager"
            decoding="async"
            alt="Smart Card Solutions"
            src="/cipta-logotype%202-1500h.png"
            fetchpriority="high"
            className="home-thq-image1-elm"
          />
          <div data-thq="thq-navbar-nav" className="home-thq-desktop-menu-elm">
            <nav className="home-thq-links-elm1">
              <a href="#home" className="home-thq-link1-elm1 thq-body-small">
                Home
              </a>
              <a
                href="#About Us"
                className="home-thq-link4-elm1 thq-body-small"
              >
                About Us
              </a>
              <a
                href="#Acknowledgment"
                className="home-thq-link3-elm1 thq-body-small"
              >
                Acknowedgement
              </a>
              <a
                href="#Services"
                className="home-thq-link2-elm1 thq-body-small"
              >
                Services
              </a>
              <a
                href="#Tab Selector 2"
                className="home-thq-link5-elm1 thq-body-small"
              >
                Product
              </a>
            </nav>
            <a href="#About Us" className="home-thq-link5-elm2 thq-body-small">
              Get Started
            </a>
          </div>
          <div data-thq="thq-burger-menu" className="home-thq-burger-menu-elm">
            <svg viewBox="0 0 1024 1024" className="home-icon1">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div data-thq="thq-mobile-menu" className="home-thq-mobile-menu-elm">
            <div className="home-thq-nav-elm">
              <div className="home-thq-top-elm">
                <img
                  loading="eager"
                  decoding="async"
                  alt="Smart Card Solutions"
                  src="/cipta-logotype%202-1500h.png"
                  className="home-thq-logo-elm"
                />
                <div
                  data-thq="thq-close-menu"
                  className="home-thq-close-menu-elm"
                >
                  <svg viewBox="0 0 1024 1024" className="home-icon3">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="home-thq-links-elm2">
                <a
                  href="#home"
                  className="home-thq-link1-elm2 thq-link thq-body-small"
                >
                  Home
                </a>
                <a
                  href="#About Us"
                  className="home-thq-link4-elm2 thq-link thq-body-small"
                >
                  About Us
                </a>
                <a
                  href="#Acknowledgment"
                  className="home-thq-link3-elm2 thq-link thq-body-small"
                >
                  Acknowedgement
                </a>
                <a
                  href="#Services"
                  className="home-thq-link2-elm2 thq-link thq-body-small"
                >
                  Services
                </a>
                <a
                  href="#Tab Selector 2"
                  className="home-thq-link5-elm3 thq-link thq-body-small"
                >
                  Product
                </a>
              </nav>
              <div className="home-thq-buttons-elm"></div>
              <a
                href="#About Us"
                className="home-thq-link5-elm4 thq-body-small"
              >
                Get Started
              </a>
            </div>
          </div>
        </header>
      </header>
      <div id="home" className="home-thq-home-elm">
        <div className="home-thq-frame115-elm">
          <div className="home-thq-frame116-elm">
            <span className="home-thq-text-elm100 DisplayD2M">
              Creating Simple Life
            </span>
            <span className="home-thq-text-elm101 BodyB1R">
              Over 25 years of expertise in advancing smart card technology and
              industry-leading solutions.
            </span>
            <div className="home-thq-frame112-elm">
              <span className="home-thq-text-elm102 BodyB2M">
                Let’s Get Started
              </span>
              <div className="home-thq-frame114-elm">
                <img
                  loading="eager"
                  decoding="async"
                  alt="arrowupright1318"
                  src="/external/arrowupright1318-tw3.svg"
                  className="home-thq-arrowupright-elm"
                />
              </div>
            </div>
          </div>
          <div className="home-thq-frame119-elm1">
            <div className="home-thq-frame117-elm">
              <div className="home-thq-frame118-elm10">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="resfresh1318"
                  src="/external/resfresh1318-lw1j.svg"
                  className="home-thq-resfresh-elm"
                />
              </div>
              <div className="home-thq-frame120-elm1">
                <span className="home-thq-text-elm103 HeadingH5M">
                  End-to-End Smart Card Solutions
                </span>
                <span className="home-thq-text-elm104 BodyB3R">
                  Equipped with advanced production lines and dedicated R&amp;D,
                  we deliver end-to-end smart card solutions to meet industry
                  challenges head-on.
                </span>
              </div>
            </div>
            <div className="home-thq-frame119-elm2">
              <div className="home-thq-frame118-elm11">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="lightbulb1319"
                  src="/external/lightbulb1319-s19.svg"
                  className="home-thq-lightbulb-elm1"
                />
              </div>
              <div className="home-thq-frame120-elm2">
                <span className="home-thq-text-elm105 HeadingH5M">
                  Innovative Product Development
                </span>
                <span className="home-thq-text-elm106 BodyB3R">
                  From design to production, our team partners with you to
                  create tailored smart card solutions that meet evolving market
                  demands.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="About Us" className="home-thq-about-us-elm">
        <div className="home-container3">
          <div className="home-thq-frame122-elm">
            <div className="home-thq-frame123-elm">
              <span className="home-thq-text-elm107 HeadingH4M">About Us</span>
            </div>
            <span className="home-thq-text-elm108">
              “Life is a form of innovation, always changing. Every Innovation
              begins with the small thing and the simple thing.”
            </span>
          </div>
          <div className="home-thq-frame132-elm">
            <div className="home-thq-frame126-elm">
              <span className="home-thq-text-elm109 BodyB2R">
                <span>Cipta</span>
                <span>
                  {' '}
                  is a leader in smart card innovation with over
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>10 years of experience</span>
                <span>
                  {' '}
                  and a team of
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>800+ professionals</span>
                <span>
                  . Originally founded as PT Cipta Srigati Lestari (CSL), we
                  evolved from packaging and printing to provide comprehensive
                  smart card solutions, including management systems, Secure
                  Access Modules (SAM), and NFC technology.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </span>
              <span className="home-thq-text-elm116 BodyB2R">
                <span>
                  Rebranded in 2014, Cipta is the only Indonesian company
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>
                  certified by the GSM Alliance&apos;s Security Accreditation
                  Scheme
                </span>
                <span>
                  {' '}
                  (SAS) and is pursuing EMV certification for global expansion.
                  With a commitment to innovation and excellence, we are
                  dedicated to meeting the dynamic needs of the smart card
                  market.
                </span>
              </span>
            </div>
            <div className="home-thq-frame129-elm1">
              <div className="home-thq-frame127-elm1">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="creditcard1320"
                  src="/external/creditcard1320-e762.svg"
                  className="home-thq-creditcard-elm1"
                />
                <span className="home-thq-text-elm120 HeadingH2M">
                  15 Million+
                </span>
                <span className="home-thq-text-elm121 BodyB3R">
                  Cards produced annually, ensuring we meet the demands of a
                  rapidly growing global market.
                </span>
              </div>
              <div className="home-thq-frame131-elm">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="briefcase1321"
                  src="/external/briefcase1321-1l4l.svg"
                  className="home-thq-briefcase-elm"
                />
                <span className="home-thq-text-elm122 HeadingH2M">
                  25 Years+
                </span>
                <span className="home-thq-text-elm123 BodyB3R">
                  Cipta has established itself as a trusted leader in smart card
                  technology, driving innovation across various sectors.
                </span>
              </div>
              <div className="home-thq-frame130-elm">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="award1321"
                  src="/external/award1321-thke.svg"
                  className="home-thq-award-elm1"
                />
                <span className="home-thq-text-elm124 HeadingH2M">
                  10 Patents+
                </span>
                <span className="home-thq-text-elm125 BodyB3R">
                  Our commitment to innovation has resulted in over 10 patents,
                  positioning Cipta as a pioneer in smart card technology
                  development.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-key-figures-elm">
        <div className="home-thq-frame135-elm1">
          <div className="home-container4">
            <div className="home-thq-frame141-elm1">
              <span className="home-thq-text-elm126">Key Figures</span>
              <div className="home-thq-frame134-elm">
                <span className="home-thq-text-elm127 BodyB1R">
                  Cipta operates a state-of-the-art manufacturing facility with
                  six smart card production lines and three IC module lines. We
                  prioritize research and development, investing in our human
                  capital to address the dynamic challenges of the smart card
                  industry.
                </span>
                <span className="home-thq-text-elm128 BodyB1R">
                  <span>
                    In 2012, we expanded our global footprint by opening a
                    branch office in
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Dubai</span>
                  <span>
                    ,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>United Arab Emirates</span>
                  <span>
                    , to tap into emerging markets in
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Africa</span>
                  <span>
                    {' '}
                    and enhance our presence in
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Europe</span>
                  <span>
                    {' '}
                    and the
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Middle East.</span>
                </span>
              </div>
            </div>
            <div className="home-thq-frame145-elm1">
              <div className="home-thq-frame143-elm1">
                <div className="home-thq-frame127-elm2">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="simcard1323"
                    src="/external/simcard1323-2y3.svg"
                    className="home-thq-simcard-elm"
                  />
                  <span className="home-thq-text-elm139 HeadingH2M">
                    5 Million+
                  </span>
                  <span className="home-thq-text-elm140 BodyB3R">
                    per month Smart card produced
                  </span>
                </div>
                <div className="home-thq-frame128-elm1">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="box1323"
                    src="/external/box1323-ab3.svg"
                    className="home-thq-box-elm"
                  />
                  <span className="home-thq-text-elm141 HeadingH2M">
                    10 Billion+
                  </span>
                  <span className="home-thq-text-elm142 BodyB3R">
                    Packaging produced
                  </span>
                </div>
              </div>
              <div className="home-thq-frame144-elm1">
                <div className="home-thq-frame127-elm3">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="users1323"
                    src="/external/users1323-w73b.svg"
                    className="home-thq-users-elm"
                  />
                  <span className="home-thq-text-elm143 HeadingH2M">250+</span>
                  <span className="home-thq-text-elm144 BodyB3R">
                    Professional employees
                  </span>
                </div>
                <div className="home-thq-frame129-elm2">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="globe1324"
                    src="/external/globe1324-6g2.svg"
                    className="home-thq-globe-elm"
                  />
                  <span className="home-thq-text-elm145 HeadingH2M">
                    Global Market
                  </span>
                  <span className="home-thq-text-elm146 BodyB3R">
                    3 Continents, 17 Overseas Countries &amp; 2 Branches.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Acknowledgment" className="home-thq-acknowledgement-elm">
        <div className="home-thq-frame133-elm1">
          <div className="home-thq-frame335-elm">
            <span className="home-thq-text-elm147">Acknowledgment</span>
            <span className="home-thq-text-elm148 BodyB1R">
              Cipta is known for quality excellence and innovation, supported by
              various accreditations.
            </span>
          </div>
          <div className="home-thq-frame339-elm">
            <div className="home-thq-frame337-elm1">
              <div className="home-thq-frame147-elm1">
                <div className="home-thq-frame118-elm12">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="trophy1325"
                    src="/external/trophy1325-c2f.svg"
                    className="home-thq-trophy-elm1"
                  />
                </div>
                <div className="home-thq-frame340-elm">
                  <span className="home-thq-text-elm149 HeadingH5SB">
                    Purchase orders award
                  </span>
                  <span className="home-thq-text-elm150 BodyB1R">
                    XL (Axiata Group)
                  </span>
                  <span className="home-thq-text-elm151 BodyB1R">2012</span>
                </div>
              </div>
              <div className="home-thq-frame336-elm1">
                <div className="home-thq-frame118-elm13">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="lightbulb1326"
                    src="/external/lightbulb1326-w36h.svg"
                    className="home-thq-lightbulb-elm2"
                  />
                </div>
                <div className="home-thq-frame341-elm">
                  <span className="home-thq-text-elm152 HeadingH5SB">
                    Pioneered &amp; implemented e-pension solution
                  </span>
                  <span className="home-thq-text-elm153 BodyB1R">BTPN</span>
                  <span className="home-thq-text-elm154 BodyB1R">2012</span>
                </div>
              </div>
              <div className="home-thq-frame337-elm2">
                <div className="home-thq-frame118-elm14">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="trophy1326"
                    src="/external/trophy1326-42ul.svg"
                    className="home-thq-trophy-elm2"
                  />
                </div>
                <div className="home-thq-frame342-elm">
                  <span className="home-thq-text-elm155 HeadingH5SB">
                    Purchase orders award
                  </span>
                  <span className="home-thq-text-elm156 BodyB1R">
                    Indosat (Qtel Group)
                  </span>
                  <span className="home-thq-text-elm157 BodyB1R">
                    2011, 2012
                  </span>
                </div>
              </div>
            </div>
            <div className="home-thq-frame338-elm">
              <div className="home-thq-frame147-elm2">
                <div className="home-thq-frame118-elm15">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="lightbulb1327"
                    src="/external/lightbulb1327-d4jr.svg"
                    className="home-thq-lightbulb-elm3"
                  />
                </div>
                <div className="home-thq-frame343-elm">
                  <span className="home-thq-text-elm158 HeadingH5SB">
                    Pioneered the first Half SIM card in Indonesia
                  </span>
                  <span className="home-thq-text-elm159 BodyB1R">
                    AXIS (STC Group)
                  </span>
                  <span className="home-thq-text-elm160 BodyB1R">2009</span>
                </div>
              </div>
              <div className="home-thq-frame336-elm2">
                <div className="home-thq-frame118-elm16">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="award1328"
                    src="/external/award1328-k7k.svg"
                    className="home-thq-award-elm2"
                  />
                </div>
                <div className="home-thq-frame344-elm">
                  <span className="home-thq-text-elm161 HeadingH5SB">
                    First Indonesian vendor to achieve Celltick certificate
                  </span>
                  <span className="home-thq-text-elm162 BodyB1R">Celtick</span>
                </div>
              </div>
              <div className="home-thq-frame337-elm3">
                <div className="home-thq-frame118-elm17">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="award1329"
                    src="/external/award1329-lb0b.svg"
                    className="home-thq-award-elm3"
                  />
                </div>
                <div className="home-thq-frame345-elm">
                  <span className="home-thq-text-elm163 HeadingH5SB">
                    First vendor to achieve SmartTrust WIB 1.3 certificate
                  </span>
                  <span className="home-thq-text-elm164 BodyB1R">
                    SmartTrust
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-member-elm1">
        <div className="home-thq-frame347-elm1">
          <span className="home-thq-text-elm165 HeadingH4M">
            Cipta is a proud member of leading global industry organizations,
            reflecting our commitment to quality and innovation.
          </span>
          <div className="home-thq-frame346-elm1">
            <img
              loading="lazy"
              decoding="async"
              alt="image1329"
              src="/external/image1329-jvq-200h.png"
              className="home-thq-image-elm10"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1329"
              src="/external/image1329-fw7d-200h.png"
              className="home-thq-image-elm11"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-hhvv-200h.png"
              className="home-thq-image-elm12"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-2yjg-200h.png"
              className="home-thq-image-elm13"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-oh7-200h.png"
              className="home-thq-image-elm14"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-fkk8-200h.png"
              className="home-thq-image-elm15"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-cwyl-200h.png"
              className="home-thq-image-elm16"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-vus8-200h.png"
              className="home-thq-image-elm17"
            />
            <img
              loading="lazy"
              decoding="async"
              alt="image1330"
              src="/external/image1330-kw8s-200h.png"
              className="home-thq-image-elm18"
            />
          </div>
        </div>
      </div>
      <div className="home-thq-certification-elm">
        <div className="home-thq-frame133-elm2">
          <span className="home-thq-text-elm166 HeadingH3SB">
            Certification
          </span>
          <div className="home-thq-frame422-elm1">
            <div className="home-thq-frame420-elm">
              <div className="home-thq-frame421-elm1">
                <div className="home-thq-frame118-elm18">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="checkcircle4523"
                    src="/external/checkcircle4523-u7d1.svg"
                    className="home-thq-checkcircle-elm1"
                  />
                </div>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle284523"
                  src="/external/rectangle284523-k2e-200h.png"
                  className="home-thq-rectangle28-elm1"
                />
              </div>
              <div className="home-thq-frame415-elm1">
                <div className="home-thq-frame423-elm1">
                  <span className="home-thq-text-elm167 HeadingH5SB">
                    ISO 14298:2021
                  </span>
                </div>
                <span className="home-thq-text-elm168 BodyB2R">
                  This certification demonstrates that PT Cipta Srigati Lestari
                  adheres to high-security standards in its printing and
                  production processes, including for sensitive documents. It
                  ensures the company’s reliability and capability in
                  safeguarding the information it handles.
                </span>
              </div>
            </div>
            <div className="home-thq-frame421-elm2">
              <div className="home-thq-frame421-elm3">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle294524"
                  src="/external/rectangle294524-iy2m-200h.png"
                  className="home-thq-rectangle29-elm1"
                />
                <div className="home-thq-frame118-elm19">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="checkcircle4524"
                    src="/external/checkcircle4524-jhlg.svg"
                    className="home-thq-checkcircle-elm2"
                  />
                </div>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle284524"
                  src="/external/rectangle284524-i8y-200h.png"
                  className="home-thq-rectangle28-elm2"
                />
              </div>
              <div className="home-thq-frame415-elm2">
                <div className="home-thq-frame424-elm1">
                  <span className="home-thq-text-elm169 HeadingH5SB">
                    ISO 45001:2018
                  </span>
                </div>
                <span className="home-thq-text-elm170 BodyB2R">
                  This certification focuses on Occupational Health and Safety
                  Management Systems. It ensures that the company provides a
                  safe working environment, reduces the risk of workplace
                  accidents, and promotes employee well-being.
                </span>
              </div>
            </div>
            <div className="home-thq-frame422-elm2">
              <div className="home-thq-frame421-elm4">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle294525"
                  src="/external/rectangle294525-wsp7-200h.png"
                  className="home-thq-rectangle29-elm2"
                />
                <div className="home-thq-frame118-elm20">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="checkcircle4525"
                    src="/external/checkcircle4525-u3av.svg"
                    className="home-thq-checkcircle-elm3"
                  />
                </div>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle284525"
                  src="/external/rectangle284525-r6v-200h.png"
                  className="home-thq-rectangle28-elm3"
                />
              </div>
              <div className="home-thq-frame415-elm3">
                <div className="home-thq-frame424-elm2">
                  <span className="home-thq-text-elm171 HeadingH5SB">
                    ISO 14001:2015
                  </span>
                </div>
                <span className="home-thq-text-elm172 BodyB2R">
                  This certification emphasizes Environmental Management
                  Systems. PT Cipta Srigati Lestari is committed to minimizing
                  its environmental impact by adopting sustainable and efficient
                  resource management practices.
                </span>
              </div>
            </div>
            <div className="home-thq-frame423-elm2">
              <div className="home-thq-frame421-elm5">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle294526"
                  src="/external/rectangle294526-3zlo-200h.png"
                  className="home-thq-rectangle29-elm3"
                />
                <div className="home-thq-frame118-elm21">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="checkcircle4526"
                    src="/external/checkcircle4526-pen.svg"
                    className="home-thq-checkcircle-elm4"
                  />
                </div>
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle284526"
                  src="/external/rectangle284526-tw6b-200h.png"
                  className="home-thq-rectangle28-elm4"
                />
              </div>
              <div className="home-thq-frame415-elm4">
                <div className="home-thq-frame424-elm3">
                  <span className="home-thq-text-elm173 HeadingH5SB">
                    ISO 9001:2015
                  </span>
                </div>
                <span className="home-thq-text-elm174 BodyB2R">
                  This certification demonstrates the implementation of a
                  high-quality Management System. PT Cipta Srigati Lestari is
                  dedicated to consistently delivering top-notch products and
                  services that meet customer expectations.
                </span>
              </div>
            </div>
            <div className="home-thq-frame424-elm4">
              <div className="home-thq-frame421-elm6">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="Rectangle294527"
                  src="/external/rectangle294527-mtdn-200h.png"
                  className="home-thq-rectangle29-elm4"
                />
                <div className="home-thq-frame118-elm22">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="checkcircle4527"
                    src="/external/checkcircle4527-olvl.svg"
                    className="home-thq-checkcircle-elm5"
                  />
                </div>
              </div>
              <div className="home-thq-frame415-elm5">
                <div className="home-thq-frame424-elm5">
                  <span className="home-thq-text-elm175 HeadingH5SB">
                    ISO 27001:2013
                  </span>
                </div>
                <span className="home-thq-text-elm176 BodyB2R">
                  This certification represents the international standard for
                  Information Security Management Systems (ISMS). It ensures the
                  protection of sensitive data and information from threats or
                  breaches, safeguarding the company’s and clients’ interests.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Services" className="home-thq-services-elm">
        <div className="home-thq-frame135-elm2">
          <div className="home-thq-frame141-elm2">
            <span className="home-thq-text-elm177">Services</span>
            <span className="home-thq-text-elm178 BodyB1R">
              We provide innovative, end-to-end solutions designed to support
              your business growth and meet evolving industry demands. Our
              expertise ensures the highest standards in every project we
              deliver.
            </span>
          </div>
          <div className="home-thq-frame145-elm2">
            <div className="home-thq-frame143-elm2">
              <div className="home-thq-frame127-elm4">
                <div className="home-thq-frame118-elm23">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="illustration1331"
                    src="/external/illustration1331-p73r.svg"
                    className="home-thq-illustration-elm"
                  />
                </div>
                <span className="home-thq-text-elm179 HeadingH3M">
                  Product Development
                </span>
                <span className="home-thq-text-elm180 BodyB3R">
                  <span>
                    Our team collaborates with you to
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>design</span>
                  <span>
                    ,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>develop</span>
                  <span>
                    , and bring smart card products to
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>market</span>
                  <span>
                    , offering expertise in
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>branding</span>
                  <span>
                    ,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>R&amp;D</span>
                  <span>
                    , and effective product launch
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>strategies.</span>
                </span>
              </div>
              <div className="home-thq-frame128-elm2">
                <div className="home-thq-frame118-elm24">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="cog1332"
                    src="/external/cog1332-kre.svg"
                    className="home-thq-cog-elm"
                  />
                </div>
                <span className="home-thq-text-elm193 HeadingH3M">
                  Smart Card Manufacturing
                </span>
                <span className="home-thq-text-elm194 BodyB3R">
                  <span>
                    Our facilities handle all aspects of smart card
                    manufacturing. With six smart card and three IC module
                    lines, we produce over 1
                  </span>
                  <span>6 million smart cards monthly.</span>
                </span>
              </div>
            </div>
            <div className="home-thq-frame144-elm2">
              <div className="home-thq-frame127-elm5">
                <div className="home-thq-frame118-elm25">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="processor1332"
                    src="/external/processor1332-ohgr.svg"
                    className="home-thq-processor-elm"
                  />
                </div>
                <span className="home-thq-text-elm197 HeadingH3M">
                  Smart Card OS &amp; Applet Development
                </span>
                <span className="home-thq-text-elm198 BodyB3R">
                  <span>
                    Our Smart Card R&amp;D team develops user-friendly
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>operating systems</span>
                  <span>
                    {' '}
                    and tailored applications for
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>telecommunications</span>
                  <span>
                    ,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>payments</span>
                  <span>
                    , and
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>identity sectors</span>
                  <span>
                    . We also offer essential software development tools for all
                    phases of the smart card lifecycle.
                  </span>
                </span>
              </div>
              <div className="home-thq-frame129-elm3">
                <div className="home-thq-frame118-elm26">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="creditcard1333"
                    src="/external/creditcard1333-10s.svg"
                    className="home-thq-creditcard-elm2"
                  />
                </div>
                <span className="home-thq-text-elm208 HeadingH3M">
                  Smart Card Solutions
                </span>
                <span className="home-thq-text-elm209 BodyB3R">
                  <span>
                    We provide comprehensive smart card solutions, including
                    enrollment with
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Biometric Systems</span>
                  <span>
                    ,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Card Management Systems</span>
                  <span>
                    {' '}
                    (CMS), and customizable
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Personalization Systems</span>
                  <span>
                    . Our tailored solutions cater to various industries,
                    ensuring
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>secure</span>
                  <span> and efficient deployment.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TabSelector
        text2={
          <Fragment>
            <span className="home-text10">Card Production</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="home-text11">
              Smart Card &amp; Personalization
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="home-text12">Prepress</span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="home-text13">
              This term used in the printing and publishing industries for the
              processes and procedures that occur between the creation of print
              layout and final printing.
            </span>
          </Fragment>
        }
        text6={
          <Fragment>
            <span className="home-text14">Sheet Printing</span>
          </Fragment>
        }
        text7={
          <Fragment>
            <span className="home-text15">
              Before card producing, the front and back side layers have to be
              printed with specific layout.
            </span>
          </Fragment>
        }
        text8={
          <Fragment>
            <span className="home-text16">Sheet Collating</span>
          </Fragment>
        }
        text9={
          <Fragment>
            <span className="home-text17">
              This step means collating and alignment of different sheetlayers
              for laminated cards.
            </span>
          </Fragment>
        }
        text10={
          <Fragment>
            <span className="home-text18">Sheet Laminating</span>
          </Fragment>
        }
        text11={
          <Fragment>
            <span className="home-text19">
              After the correct alignment and prefixing of the single sheet
              layers, they have to be laminated to get a stable card body.
            </span>
          </Fragment>
        }
        text12={
          <Fragment>
            <span className="home-text20">Card Punching</span>
          </Fragment>
        }
        text13={
          <Fragment>
            <span className="home-text21">
              At this process, a single card is punched out of the laminated
              sheets.
            </span>
          </Fragment>
        }
        text21={
          <Fragment>
            <span className="home-text22">IC Module</span>
          </Fragment>
        }
        text22={
          <Fragment>
            <span className="home-text23">Card Production</span>
          </Fragment>
        }
        text31={
          <Fragment>
            <span className="home-text24">
              Smart Card &amp; Personalization
            </span>
          </Fragment>
        }
        text41={
          <Fragment>
            <span className="home-text25">Combined Milling Implanting</span>
          </Fragment>
        }
        text51={
          <Fragment>
            <span className="home-text26">
              This central process in the smart card production chain. Chip
              modules are punched out of the tape, placed and fixed in the
              cavity of card.
            </span>
          </Fragment>
        }
        text61={
          <Fragment>
            <span className="home-text27">Plug Punching</span>
          </Fragment>
        }
        text71={
          <Fragment>
            <span className="home-text28">
              Plug punching is a precise process used to pre-punch SIM plugs,
              ensuring consistent quality and accuracy for optimal card
              performance.
            </span>
          </Fragment>
        }
        text81={
          <Fragment>
            <span className="home-text29">Personalization</span>
          </Fragment>
        }
        text91={
          <Fragment>
            <span className="home-text30">
              This step will make each card into a distinctive, an individual
              item which cannot be forgotten. The use of the most-up-todate
              production technology supports every type of optical
              personalization.
            </span>
          </Fragment>
        }
        text101={
          <Fragment>
            <span className="home-text31">Fulfillment</span>
          </Fragment>
        }
        text111={
          <Fragment>
            <span className="home-text32">
              A variety of fully secure solutions, ranging from simple packages
              and card carriers are to more sophisticated packs designed to
              convey a high-end image of your product.
            </span>
          </Fragment>
        }
        text121={
          <Fragment>
            <span className="home-text33">Delivery</span>
          </Fragment>
        }
        text131={
          <Fragment>
            <span className="home-text34">
              After your smart card produced and packaged with your special
              packaging, we are ready to deliver the smart card into your place.
            </span>
          </Fragment>
        }
        text211={
          <Fragment>
            <span className="home-text35">IC Module</span>
          </Fragment>
        }
        text221={
          <Fragment>
            <span className="home-text36">Card Production</span>
          </Fragment>
        }
        text311={
          <Fragment>
            <span className="home-text37">
              Smart Card &amp; Personalization
            </span>
          </Fragment>
        }
        text2111={
          <Fragment>
            <span className="home-text38">IC Module</span>
          </Fragment>
        }
        onClickBg={
          <Fragment>
            <span className="home-text39">Smart Card Production Process</span>
          </Fragment>
        }
        rootClassName="tab-selectorroot-class-name"
      ></TabSelector>
      <TabSelector2
        rootClassName="tab-selector2root-class-name"
        tabSelector2Id="Tab Selector 2"
      ></TabSelector2>
      <div className="home-thq-member-elm2">
        <div className="home-thq-frame347-elm2">
          <span className="home-thq-text-elm219 HeadingH4M">
            Trusted by Clients Around the Globe
          </span>
          <div className="home-thq-frame382-elm">
            <span className="home-thq-text-elm220 BodyB1M">Indonesia</span>
            <div className="home-thq-frame346-elm2">
              <img
                loading="lazy"
                decoding="async"
                alt="image4674"
                src="/external/image4674-asfl-200h.png"
                className="home-thq-image-elm19"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4674"
                src="/external/image4674-m56-200h.png"
                className="home-thq-image-elm20"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4674"
                src="/external/image4674-07xt-200h.png"
                className="home-thq-image-elm21"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-o0g-200h.png"
                className="home-thq-image-elm22"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-7xtd-200h.png"
                className="home-thq-image-elm23"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-1aai-200h.png"
                className="home-thq-image-elm24"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-ah2d-200h.png"
                className="home-thq-image-elm25"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-3zsg-200h.png"
                className="home-thq-image-elm26"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-dqi4-200h.png"
                className="home-thq-image-elm27"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-hik-200h.png"
                className="home-thq-image-elm28"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-br1g-200h.png"
                className="home-thq-image-elm29"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-j31k-200h.png"
                className="home-thq-image-elm30"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4675"
                src="/external/image4675-gnkc-200h.png"
                className="home-thq-image-elm31"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-ytan-200h.png"
                className="home-thq-image-elm32"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-8lye-200h.png"
                className="home-thq-image-elm33"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-rx2e-200h.png"
                className="home-thq-image-elm34"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-wxa-200h.png"
                className="home-thq-image-elm35"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-jsul-200h.png"
                className="home-thq-image-elm36"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-2q0a-200h.png"
                className="home-thq-image-elm37"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-mkmq-200h.png"
                className="home-thq-image-elm38"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-8ujl-200h.png"
                className="home-thq-image-elm39"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-rdqm-200h.png"
                className="home-thq-image-elm40"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4676"
                src="/external/image4676-lj4q-200h.png"
                className="home-thq-image-elm41"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-z0xa-200h.png"
                className="home-thq-image-elm42"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-tfrd-200h.png"
                className="home-thq-image-elm43"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-z2am-200h.png"
                className="home-thq-image-elm44"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-ekln-200h.png"
                className="home-thq-image-elm45"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-607k-200h.png"
                className="home-thq-image-elm46"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-wsub-200h.png"
                className="home-thq-image-elm47"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-jifa-200h.png"
                className="home-thq-image-elm48"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-j6m-200h.png"
                className="home-thq-image-elm49"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-pccf-200h.png"
                className="home-thq-image-elm50"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4677"
                src="/external/image4677-oog5-200h.png"
                className="home-thq-image-elm51"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4678"
                src="/external/image4678-v3v4-200h.png"
                className="home-thq-image-elm52"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4678"
                src="/external/image4678-9l1b-200h.png"
                className="home-thq-image-elm53"
              />
              <img
                loading="lazy"
                decoding="async"
                alt="image4678"
                src="/external/image4678-orfo-200h.png"
                className="home-thq-image-elm54"
              />
            </div>
          </div>
          <div className="home-thq-frame385-elm1">
            <div className="home-thq-frame383-elm">
              <span className="home-thq-text-elm221 BodyB1M">
                United Kingdom
              </span>
              <div className="home-thq-frame346-elm3">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image4678"
                  src="/external/image4678-ww9n-200h.png"
                  className="home-thq-image-elm55"
                />
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image4678"
                  src="/external/image4678-315-200h.png"
                  className="home-thq-image-elm56"
                />
              </div>
            </div>
            <div className="home-thq-frame385-elm2">
              <span className="home-thq-text-elm222 BodyB1M">Vietnam</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4679"
                src="/external/image4679-9f7j-200h.png"
                className="home-thq-image-elm57"
              />
            </div>
            <div className="home-thq-frame387-elm">
              <span className="home-thq-text-elm223 BodyB1M">Morocco</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4679"
                src="/external/image4679-gmkg-200h.png"
                className="home-thq-image-elm58"
              />
            </div>
            <div className="home-thq-frame388-elm">
              <span className="home-thq-text-elm224 BodyB1M">Iraq</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4679"
                src="/external/image4679-730q-200h.png"
                className="home-thq-image-elm59"
              />
            </div>
            <div className="home-thq-frame389-elm">
              <span className="home-thq-text-elm225 BodyB1M">Afghanistan</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4680"
                src="/external/image4680-7bli-200h.png"
                className="home-thq-image-elm60"
              />
            </div>
            <div className="home-thq-frame390-elm">
              <span className="home-thq-text-elm226 BodyB1M">Mauritania</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4680"
                src="/external/image4680-w9lt-200h.png"
                className="home-thq-image-elm61"
              />
            </div>
            <div className="home-thq-frame391-elm">
              <span className="home-thq-text-elm227 BodyB1M">Uganda</span>
              <div className="home-thq-frame346-elm4">
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image4680"
                  src="/external/image4680-1d0e-200h.png"
                  className="home-thq-image-elm62"
                />
                <img
                  loading="lazy"
                  decoding="async"
                  alt="image4680"
                  src="/external/image4680-1a8-200h.png"
                  className="home-thq-image-elm63"
                />
              </div>
            </div>
            <div className="home-thq-frame392-elm">
              <span className="home-thq-text-elm228 BodyB1M">Kenya</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4681"
                src="/external/image4681-7r2q-200h.png"
                className="home-thq-image-elm64"
              />
            </div>
            <div className="home-thq-frame393-elm">
              <span className="home-thq-text-elm229 BodyB1M">Zambia</span>
              <img
                loading="lazy"
                decoding="async"
                alt="image4681"
                src="/external/image4681-dnnh-200h.png"
                className="home-thq-image-elm65"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="home-container5">
        <div className="home-thq-frame394-elm">
          <div className="home-thq-frame401-elm">
            <div className="home-thq-ciptalogotype2-elm">
              <div className="home-thq-layer1-elm1">
                <div className="home-thq-group-elm1">
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1342"
                    src="/external/vector1342-fx6y.svg"
                    className="home-thq-vector-elm10"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1342"
                    src="/external/vector1342-2w1r.svg"
                    className="home-thq-vector-elm11"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1342"
                    src="/external/vector1342-zrge.svg"
                    className="home-thq-vector-elm12"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1342"
                    src="/external/vector1342-1o2.svg"
                    className="home-thq-vector-elm13"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1342"
                    src="/external/vector1342-e8e.svg"
                    className="home-thq-vector-elm14"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-9216.svg"
                    className="home-thq-vector-elm15"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-a7g.svg"
                    className="home-thq-vector-elm16"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-vts.svg"
                    className="home-thq-vector-elm17"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-9tkl.svg"
                    className="home-thq-vector-elm18"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-k5sk.svg"
                    className="home-thq-vector-elm19"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-kid.svg"
                    className="home-thq-vector-elm20"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-41mv.svg"
                    className="home-thq-vector-elm21"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-pxz8.svg"
                    className="home-thq-vector-elm22"
                  />
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="Vector1343"
                    src="/external/vector1343-hzo.svg"
                    className="home-thq-vector-elm23"
                  />
                </div>
              </div>
            </div>
            <div className="home-thq-frame403-elm">
              <span className="home-thq-text-elm230 HeadingH2SB">
                Get in Touch with Us
              </span>
              <span className="home-thq-text-elm231 BodyB1R">
                Have questions or need assistance? Contact us today, and our
                team will be happy to help you!
              </span>
            </div>
          </div>
          <div className="home-thq-frame400-elm">
            <div className="home-thq-frame402-elm">
              <div className="home-thq-frame397-elm">
                <span className="home-thq-text-elm232 BodyB3M">Full name</span>
                <div className="home-thq-frame396-elm1">
                  <span className="home-thq-text-elm233 BodyB3R">
                    Enter your full name
                  </span>
                </div>
              </div>
              <div className="home-thq-frame399-elm">
                <span className="home-thq-text-elm234 BodyB3M">
                  Email address
                </span>
                <div className="home-thq-frame396-elm2">
                  <span className="home-thq-text-elm235 BodyB3R">
                    email@address.com
                  </span>
                </div>
              </div>
            </div>
            <div className="home-thq-frame398-elm">
              <span className="home-thq-text-elm236 BodyB3M">
                Send us a message
              </span>
              <div className="home-thq-frame396-elm3">
                <span className="home-thq-text-elm237 BodyB3R">
                  Write us a message...
                </span>
              </div>
            </div>
            <div className="home-thq-frame106-elm1">
              <span className="home-thq-text-elm238 BodyB2M">Send Message</span>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-footer-elm">
        <div className="home-thq-frame410-elm">
          <div className="home-thq-frame407-elm">
            <div className="home-thq-frame408-elm">
              <div className="home-thq-ciptalogotypemono1-elm">
                <div className="home-thq-layer1-elm2">
                  <div className="home-thq-group-elm2">
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="Vector1346"
                      src="/external/vector1346-6fq.svg"
                      className="home-thq-vector-elm24"
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="Vector1346"
                      src="/external/vector1346-ia28.svg"
                      className="home-thq-vector-elm25"
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="Vector1346"
                      src="/external/vector1346-n8jl.svg"
                      className="home-thq-vector-elm26"
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="Vector1346"
                      src="/external/vector1346-7kjs.svg"
                      className="home-thq-vector-elm27"
                    />
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="Vector1346"
                      src="/external/vector1346-z0lp.svg"
                      className="home-thq-vector-elm28"
                    />
                    <div className="home-thq-group-elm3">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="Vector1347"
                        src="/external/vector1347-1kpi.svg"
                        className="home-thq-vector-elm29"
                      />
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="Vector1347"
                        src="/external/vector1347-rfyd.svg"
                        className="home-thq-vector-elm30"
                      />
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="Vector1347"
                        src="/external/vector1347-u7nq.svg"
                        className="home-thq-vector-elm31"
                      />
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="Vector1347"
                        src="/external/vector1347-gwa.svg"
                        className="home-thq-vector-elm32"
                      />
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="Vector1347"
                        src="/external/vector1347-qsqua.svg"
                        className="home-thq-vector-elm33"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-thq-frame404-elm">
                <span className="home-thq-text-elm239 BodyB2M">
                  PT. Cipta Srigati Lestari
                </span>
                <span className="home-thq-text-elm240 BodyB3R">
                  Plaza Simatupang Lantai. 2 Jl. TB. Simatupang Kav. IS No.01
                  Pd. Pinang, Kec. Kby. Lama Kota Jakarta Selatan, Daerah Khusus
                  Ibukota Jakarta 12310
                </span>
              </div>
            </div>
            <div className="home-thq-frame406-elm">
              <div className="home-thq-frame405-elm">
                <span className="home-thq-text-elm241 BodyB3R">Home</span>
                <a href="#About Us" className="home-thq-text-elm242 BodyB3R">
                  About Us
                </a>
                <a
                  href="#Acknowledgment"
                  className="home-thq-text-elm243 BodyB3R"
                >
                  Acknowledgement
                </a>
                <a href="#Services" className="home-thq-text-elm244 BodyB3R">
                  Service
                </a>
                <a
                  href="#Tab Selector 2"
                  className="home-thq-text-elm245 BodyB3R"
                >
                  Product
                </a>
              </div>
              <div className="home-thq-frame106-elm2">
                <span className="home-thq-text-elm246 BodyB3M">Contact Us</span>
              </div>
            </div>
          </div>
          <div className="home-thq-frame409-elm">
            <span className="home-thq-text-elm247 BodyB3R">
              © 2024 Cipta. All rights reserved
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
